// extracted by mini-css-extract-plugin
export default {"productGrid":"z2-z","centerLink":"A2-z","productSection":"B2-z","item":"C2-z","ctaButton":"D2-z"};